import React, { useState, useRef } from 'react';

interface MoldShotProgressGradientProps {
  shotCount: number;
  servicingAlertShotThreshold: number;
  servicingMaxShotThreshold: number;
  maxShotCount: number;
}

const MoldShotProgressGradient: React.FC<MoldShotProgressGradientProps> = ({
  shotCount,
  servicingAlertShotThreshold,
  servicingMaxShotThreshold,
  maxShotCount,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const progressBarRef = useRef(null);
  const shotPercentage = (shotCount / servicingMaxShotThreshold) * 100;
  const servicingPercentage =
    (servicingAlertShotThreshold / servicingMaxShotThreshold) * 100;
  const warningToServicePercentage =
    (shotCount / servicingAlertShotThreshold) * 100;

  const getColor = () => {
    if (shotCount > servicingMaxShotThreshold) return 'bg-red-600';
    if (shotCount > servicingAlertShotThreshold) return 'bg-red-400';
    if (warningToServicePercentage >= 80) return 'bg-amber-200';
    // if (shotPercentage > 60) return 'bg-amber-300'
    return 'bg-gray-300';
  };

  const barColor = getColor();

  return (
    <div
      className="w-full"
      ref={progressBarRef}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={'absolute top-0 left-0 h-full rounded-full ' + barColor}
          style={{ width: `${shotPercentage}%` }}
        />
        <div
          className="absolute top-0 left-0 h-full border-r-2 border-yellow-400"
          style={{ left: `${servicingPercentage}%` }}
        />
      </div>
      {showTooltip && (
        <div className="absolute z-20 p-2 bg-white border border-gray-200 rounded shadow-lg text-xs -mt-5 transform -translate-y-full">
          <div>ชอตสะสมในรอบล้าง: {shotCount.toLocaleString()}</div>
          <div>
            ชอตเตือนเซอร์วิส: {servicingAlertShotThreshold.toLocaleString()}
          </div>
          <div>
            ชอตที่ต้องเซอร์วิส: {servicingMaxShotThreshold.toLocaleString()}
          </div>
          <div>
            Mold การันตี: {maxShotCount.toLocaleString()}
          </div>
        </div>
      )}
      <div className="flex justify-between mt-1 text-sm text-gray-600">
        <span>{shotCount.toLocaleString()}</span>
        <span>{servicingAlertShotThreshold.toLocaleString()}</span>
        <span>{servicingMaxShotThreshold.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default MoldShotProgressGradient;
